// 'SteamingContentTray': //AXB-81
import { StreamingContentTray } from '../../../domain/streaming-content-tray';
import {
  CreateVodContentPageItemRequestApiModel,
  UpdateVodContentPageItemRequestApiModel,
  VodContentPageItemApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  layoutMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  dthStatusMapper,
  layoutMapperApiToDomain,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { StreamingContentTrayFormViewModel } from './streaming-content-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  layoutMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'StreamingContentTray'

/**
 * DOMAIN -> API
 */

export const mapStreamingContentTrayDomainModelToApiModel = (
  item: StreamingContentTray,
  pageVersionId?: string,
  tenantId?: string
): CreateVodContentPageItemRequestApiModel & UpdateVodContentPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    layoutMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    feedId: item.feedId,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapStreamingContentTrayApiModelToDomainModel = (vodContent: VodContentPageItemApiModel): StreamingContentTray => {
  return remainderMapper(
    mapperPipe(
      vodContent,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperDomainToApi,
      layoutMapperApiToDomain,
      dthStatusMapper
    ),
    () => ({
      type: 'StreamingContentTray',
      feedId: vodContent.feedId,
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapStreamingContentTrayDomainModelToViewModel = (value: StreamingContentTray): StreamingContentTrayFormViewModel => {
  const commonProperties = mapperPipe(
    value,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.StreamingContentTray, // AXB-81
    feedId: value.feedId,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapStreamingContentTrayViewModelToDomainModel = (vm: StreamingContentTrayFormViewModel): StreamingContentTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'StreamingContentTray', // AXB-81
    feedId: vm.feedId,
  }));
};
